@if (config.zClosable || config.zClosable === undefined) {
  <button data-testid="z-close-header-button" z-button zType="ghost" zSize="sm" class="absolute right-2 top-2 text-red-600 hover:text-red-700 hover:bg-red-50" (click)="onCloseClick()">
    <i class="icon-x text-lg"></i>
  </button>
}

@if (config.zTitle || config.zDescription) {
  <header class="flex flex-col space-y-1.5 text-center sm:text-left">
    @if (config.zTitle) {
      <h4 data-testid="z-title" class="text-lg font-semibold leading-none tracking-tight">{{ config.zTitle }}</h4>

      @if (config.zDescription) {
        <p data-testid="z-description" class="text-sm text-muted-foreground">{{ config.zDescription }}</p>
      }
    }
  </header>
}

<main class="flex flex-col space-y-4">
  <ng-template cdkPortalOutlet></ng-template>

  @if (isStringContent) {
    <div data-testid="z-content" [innerHTML]="config.zContent"></div>
  }
</main>

@if (!config.zHideFooter) {
  <footer class="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end sm:gap-0 sm:space-x-2">
    @if (config.zCancelText !== null) {
      <button data-testid="z-cancel-button" z-button zType="outline" (click)="onCloseClick()">
        @if (config.zCancelIcon) {
          <i class="icon-{{ config.zCancelIcon }}"></i>
        }

        {{ config.zCancelText || 'Cancel' }}
      </button>
    }

    @if (config.zOkText !== null) {
      <button data-testid="z-ok-button" z-button [zType]="config.zOkDestructive ? 'destructive' : 'default'" [disabled]="config.zOkDisabled" (click)="onOkClick()">
        @if (config.zOkIcon) {
          <i class="icon-{{ config.zOkIcon }}"></i>
        }

        {{ config.zOkText || 'OK' }}
      </button>
    }
  </footer>
}
